import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
  // If the root element has child nodes, use hydrateRoot
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
  <BrowserRouter basename='/'>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  // Otherwise, use createRoot
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
     <BrowserRouter basename='/'>
      <App />
    </BrowserRouter>
    </React.StrictMode>
  );
}
